import { render, staticRenderFns } from "./autoInsurance.vue?vue&type=template&id=fda51da8&"
import script from "./autoInsurance.vue?vue&type=script&lang=js&"
export * from "./autoInsurance.vue?vue&type=script&lang=js&"
import style0 from "./autoInsurance.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports